enum DisplayNames {
  Popover = 'Popover',
  PopoverAnchor = 'PopoverAnchor',
  PopoverArrow = 'PopoverArrow',
  PopoverBody = 'PopoverBody',
  PopoverCloseButton = 'PopoverCloseButton',
  PopoverContent = 'PopoverContent',
  PopoverFooter = 'PopoverFooter',
  PopoverHeader = 'PopoverHeader',
  PopoverTrigger = 'PopoverTrigger'
}

export default DisplayNames;
